import {ParameterStore} from './ParameterStore';
import {Quote} from './Quote';

// Since we can have two possible quote objects, we pass in the quote along with the parameter store
const evalproductTypeIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'IUL';
};
const evalproductTypeTermGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'Term';
};
const evalproductTypeGULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'GUL';
};
const evalproductTypeGuaranteedGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'Guaranteed';
};
const evalproductTypeVULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'VUL';
};
const evalproductTypeWHLGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'WholeLife';
};
const evalproductTypeLSWIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'LSWIUL';
};
const evalproductTypeProsperGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'Prosper';
};
const evalproductTypeTAFEGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value == 'WholeLife' && quote.productWHL.value == 'TAFEExpress';
};
const evalameritasYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.ameritas.value == true;
};
const evalassurityLifeYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.assurityLife.value == true;
};
const evalnorthAmericanYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.northAmerican.value == true;
};
const evalproductTypeIULORroductTypeWHLGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        (evalproductTypeIULGuard(parameterStore, quote) || evalproductTypeWHLGuard(parameterStore, quote)) &&
        !evalproductTypeIULAndmooYesGuard(parameterStore, quote) &&
        !evalfgpathsetteryesGuard(parameterStore, quote)
    );
};
const evalproductTypeIULANDameritasYesANDageLt18Guard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        evalameritasYesGuard(parameterStore, quote) &&
        parameterStore.approval.age.value < 18
    );
};
const evalproductTypeVULANDameritasYesANDageLt18Guard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeVULGuard(parameterStore, quote) &&
        evalameritasYesGuard(parameterStore, quote) &&
        parameterStore.approval.age.value < 18
    );
};
const evalproductTypeIULANDameritasYesANDageGte18Guard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        evalameritasYesGuard(parameterStore, quote) &&
        parameterStore.approval.age.value >= 18
    );
};
const evalproductTypeVULANDameritasYesANDageGte18Guard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeVULGuard(parameterStore, quote) &&
        evalameritasYesGuard(parameterStore, quote) &&
        parameterStore.approval.age.value >= 18
    );
};
const evalproductTypeIULAndameritasYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeIULGuard(parameterStore, quote) && evalameritasYesGuard(parameterStore, quote);
};
const evalproductTypeIULAndmooYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeIULGuard(parameterStore, quote) && evalmooyesGuard(parameterStore, quote);
};
const evalproductTypeWHLAndmooYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeWHLGuard(parameterStore, quote) && evalmooyesGuard(parameterStore, quote);
};
const evalproductTypeIULAndFGPathsetterYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeIULGuard(parameterStore, quote) && evalfgpathsetteryesGuard(parameterStore, quote);
};
const evalproductTypeIULAndFGPathsetterYesAndStandardGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        evalfgpathsetteryesGuard(parameterStore, quote) &&
        ['StandardNonsmoker', 'StandardSmoker'].includes(quote.healthRatingFGIUL.value)
    );
};
const evalproductTypeTermANDameritasYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeTermGuard(parameterStore, quote) && evalameritasYesGuard(parameterStore, quote);
};
const evalproductTypeTermANDassurityLifeYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeTermGuard(parameterStore, quote) && evalassurityLifeYesGuard(parameterStore, quote);
};
const evallswYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.lsw.value == true;
};
const evalmooyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.moo.value == true;
};
const evalfgpathsetteryesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.fg.value == true;
};
const evalameritasTableRatingGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalameritasYesGuard(parameterStore, quote) &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        (quote.healthRatingAmeritasAdult.value == 'NonTobacco' ||
            quote.healthRatingAmeritasAdult.value == 'Tobacco' ||
            quote.healthRatingAmeritasTerm.value == 'Standard')
    );
};
const evalLSWIULTableRatingGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        (quote.lswFlexLife.value == true || quote.lswFlexLifeNL.value == true)
    );
};
const evalameritasTermTableRatingGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        (evalameritasYesGuard(parameterStore, quote) || evalassurityLifeYesGuard(parameterStore, quote)) &&
        evalproductTypeTermGuard(parameterStore, quote) &&
        (quote.healthRatingAmeritasAdult.value == 'NonTobacco' ||
            quote.healthRatingAmeritasAdult.value == 'Tobacco' ||
            quote.healthRatingAmeritasTerm.value == 'Standard')
    );
};
const evalameritasVULTableRatingGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalameritasYesGuard(parameterStore, quote) && evalproductTypeVULGuard(parameterStore, quote);
};
const evalLSWTableRatingGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evallswYesGuard(parameterStore, quote) && quote.healthRatingLSW.value == 'Standard';
};
const evalNATableRatingGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalnorthAmericanYesGuard(parameterStore, quote) && quote.healthRatingNA.value == 'Standard';
};
const evalproductTypeNotGuaranteedANDproductTypeNotProsperGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        !evalproductTypeGuaranteedGuard(parameterStore, quote) && !evalproductTypeProsperGuard(parameterStore, quote)
    );
};
const evalproductTypeProsperANDprosperRiskClassStandardTobaccoORprosperRiskClassStandardNonTobaccoGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        evalproductTypeProsperGuard(parameterStore, quote) &&
        ['StandardTobacco', 'StandardNonTobacco'].includes(quote.prosperRiskClass.value)
    );
};
// const evalprosperFixedAccountAllocationPlusprosperIndexedAccountAllocationNot100Guard = (
//     parameterStore: ParameterStore,
//     quote: Quote,
// ) => {
//     return +quote.prosperFixedAccountAllocation.value + quote.prosperIndexedAccountAllocation.value != 100;
// };
const evalproductTypeProsperANDprosperDeathBenefitOptionBIncreasingGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return evalproductTypeProsperGuard(parameterStore, quote) && quote.prosperDeathBenefitOption.value == 'BIncreasing';
};
const evalflatExtrayesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.flatExtra.value == true;
};
const evalflatExtrayesANDameritasyesornorthAmericanyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalflatExtrayesGuard(parameterStore, quote) &&
        (evalameritasYesGuard(parameterStore, quote) || evalnorthAmericanYesGuard(parameterStore, quote))
    );
};
const evalproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return evalproductTypeIULGuard(parameterStore, quote) && quote.productIUL.value == 'AmeritasIULFLXlivingbenefits';
};
const evalsolveScenarioPremiumknowncoverageANDproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.solveScenario.value == 'Premiumknowncoverage' &&
        evalproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard(parameterStore, quote)
    );
};
const evalsolveScenarioCoverageknownpremiumANDproductTypeIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.solveScenario.value == 'Coverageknownpremium' && evalproductTypeIULGuard(parameterStore, quote);
};
const evalproductTypeTermorproductTypeGULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeTermGuard(parameterStore, quote) || evalproductTypeGULGuard(parameterStore, quote);
};
const evalfaceAmountSpecifiedANDproductTypeIULLORproductTypeWHLGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        (quote.faceAmount.value == 'Specified' &&
            evalproductTypeIULGuard(parameterStore, quote) &&
            evalameritasYesGuard(parameterStore, quote)) ||
        (quote.solveForIULMoo.value == 'EasySolve' &&
            quote.easySolveOptionIULMoo.value == 'Premium' &&
            evalproductTypeIULGuard(parameterStore, quote) &&
            evalmooyesGuard(parameterStore, quote)) ||
        (quote.solveForIULFGPathsetter.value == 'PremiumSolve' &&
            evalproductTypeIULGuard(parameterStore, quote) &&
            evalfgpathsetteryesGuard(parameterStore, quote)) ||
        (quote.solveForIULFGPathsetter.value == 'NoSolve' &&
            evalproductTypeIULGuard(parameterStore, quote) &&
            evalfgpathsetteryesGuard(parameterStore, quote)) ||
        (quote.solveForWHLMoo.value == 'EasySolve' &&
            quote.easySolveOptionWHLMoo.value == 'Premium' &&
            evalproductTypeWHLAndmooYesGuard(parameterStore, quote))
    );
};
const evaleasySolveOptionWHLMooproductTypeWHLAndmooYesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.solveForWHLMoo.value == 'EasySolve' && evalproductTypeWHLAndmooYesGuard(parameterStore, quote);
};
const evalsolveForIULFGPathsetterFaceSolve = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        quote.solveForIULFGPathsetter.value == 'FaceSolve' &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        evalfgpathsetteryesGuard(parameterStore, quote)
    );
};
const evalproductGuaranteedGerberFinalExpenseANDproductTypeGuaranteedGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.productGuaranteed.value == 'GerberFinalExpense' && evalproductTypeGuaranteedGuard(parameterStore, quote)
    );
};
const evalproductGuaranteedGreatWesternFinalExpenseANDproductTypeGuaranteedGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.productGuaranteed.value == 'GreatWesternFinalExpense' &&
        evalproductTypeGuaranteedGuard(parameterStore, quote)
    );
};
const evalproductTypeIULORproductTypeVULORproductTypeWHLANDcomplianceTestNotCashValueAccumulationTestGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        (evalproductTypeIULGuard(parameterStore, quote) ||
            evalproductTypeVULGuard(parameterStore, quote) ||
            evalproductTypeWHLGuard(parameterStore, quote)) &&
        quote.complianceTest.value != 'CashValueAccumulationTest'
    );
};
const evalproductTypeIULORproductTypeVULORproductTypeWHLANDcomplianceTestNotCashValueAccumulationTestNotFGPathsetterGuard =
    (parameterStore: ParameterStore, quote: Quote) => {
        return (
            (evalproductTypeIULGuard(parameterStore, quote) ||
                evalproductTypeVULGuard(parameterStore, quote) ||
                evalproductTypeWHLGuard(parameterStore, quote)) &&
            quote.complianceTest.value != 'CashValueAccumulationTest' &&
            !evalfgpathsetteryesGuard(parameterStore, quote)
        );
    };
const evalageLt70ANDproductTypeIULANDpremiumSolveOptionLSWNotMinimumPremiumORproductTypeWHLGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        (parameterStore.approval.age.value < 70 &&
            evalproductTypeIULGuard(parameterStore, quote) &&
            quote.premiumSolveOptionLSW.value != 'MinimumPremium') ||
        (parameterStore.approval.age.value < 70 && evalproductTypeWHLGuard(parameterStore, quote))
    );
};
const evalproductTypeIULANDameritasyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalproductTypeIULGuard(parameterStore, quote) && evalameritasYesGuard(parameterStore, quote);
};
const evalageLt70ANDproductTypeLSWIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return parameterStore.approval.age.value < 70 && evalproductTypeLSWIULGuard(parameterStore, quote);
};
const evalproductTypeIULANDlswFlexLifeNLyesORlswFlexLifeyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        (quote.lswFlexLifeNL.value == true || quote.lswFlexLife.value == true)
    );
};
const evalsolveForIULNotFaceamountANDproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.solveForIUL.value != 'Faceamount' &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        quote.productIUL.value == 'AmeritasIULFLXlivingbenefits'
    );
};
const evalproductTypeTermANDproductTermNotAssurityLifeInsuranceCompanyTermLifeInsuranceGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        evalproductTypeTermGuard(parameterStore, quote) &&
        quote.productTerm.value != 'AssurityLifeInsuranceCompanyTermLifeInsurance'
    );
};
const evalproductTypeTermANDproductTermAssurityLifeInsuranceCompanyTermLifeInsuranceGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        evalproductTypeTermGuard(parameterStore, quote) &&
        quote.productTerm.value == 'AssurityLifeInsuranceCompanyTermLifeInsurance'
    );
};
const evalsolveForIULFaceamountANDproductTypeIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.solveForIUL.value == 'Faceamount' && evalproductTypeIULGuard(parameterStore, quote);
};
const evalproductTypeIULANDsolveForIULNotPremiumANDameritasyesGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        quote.solveForIUL.value != 'Premium' &&
        evalameritasYesGuard(parameterStore, quote)
    );
};
const evalproductTypeIULANDlswFlexLifeNLyesORlswFlexLifeyesANDsolveForIULLSWNotPremiumGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        evalproductTypeIULGuard(parameterStore, quote) &&
        (quote.lswFlexLifeNL.value == true || quote.lswFlexLife.value == true) &&
        quote.solveForIULLSW.value != 'Premium'
    );
};
const evalpremiumModeSpecifiedpremiumANDproductTypeIULORproductTypeWHLGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        ((quote.premiumMode.value == 'Specifiedpremium' ||
            (quote.easySolveOptionIULMoo.value === 'Face' &&
                evalproductTypeIULAndmooYesGuard(parameterStore, quote))) &&
            evalproductTypeIULGuard(parameterStore, quote)) ||
        (quote.easySolveOptionWHLMoo.value === 'Face' && evalproductTypeWHLAndmooYesGuard(parameterStore, quote))
    );
};
const evalpremiumModeSpecifiedpremiumANDproductTypeFGPathsetterGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        ((quote.solveForIULFGPathsetter.value === 'FaceSolve' && evalfgpathsetteryesGuard(parameterStore, quote)) ||
            (quote.solveForIULFGPathsetter.value === 'NoSolve' && evalfgpathsetteryesGuard(parameterStore, quote))) &&
        evalproductTypeIULGuard(parameterStore, quote)
    );
};
const evalsolveForIULPremiumANDproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.solveForIUL.value == 'Premium' &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        quote.productIUL.value == 'AmeritasIULFLXlivingbenefits'
    );
};
const evalsolveForIULLSWPremiumANDproductTypeIULANDproductIULNotAmeritasIULFLXlivingbenefitsGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.solveForIULLSW.value == 'Premium' &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        quote.productIUL.value != 'AmeritasIULFLXlivingbenefits'
    );
};
const evalsolveForIULLSWPremiumANDproductTypeIULANDproductIULNotAmeritasNotMOOIULFLXlivingbenefitsGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        quote.solveForIULLSW.value == 'Premium' &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        quote.productIUL.value != 'AmeritasIULFLXlivingbenefits' &&
        quote.productIUL.value != 'MOOIULExpress' &&
        quote.productIUL.value != 'FGPathsetter'
    );
};
const evalsolveForIULNotPremiumORsolveForIULLSWNotPremiumANDproductTypeIULGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        (quote.solveForIUL.value != 'Premium' || quote.solveForIULLSW.value != 'Premium') &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        !evalmooyesGuard(parameterStore, quote) &&
        !evalfgpathsetteryesGuard(parameterStore, quote)
    );
};
const evalpremiumEndAgeAmeritasspecifiedageANDproductTypeIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        quote.premiumEndAgeAmeritas.value == 'specifiedage' &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        evalameritasYesGuard(parameterStore, quote)
    );
};
const evalsolveForIULPremiumORsolveForIULFaceamountORsolveForIULLSWPremiumANDproductTypeIULGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        (quote.solveForIUL.value == 'Premium' ||
            quote.solveForIUL.value == 'Faceamount' ||
            quote.solveForIULLSW.value == 'Premium') &&
        evalproductTypeIULGuard(parameterStore, quote) &&
        evalameritasYesGuard(parameterStore, quote)
    );
};
const evalsolveForIULCashflowANDproductTypeIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.solveForIUL.value == 'Cashflow' && evalproductTypeIULGuard(parameterStore, quote);
};
const evalsolveForIULNotCashflowANDproductTypeIULORroductTypeWHLGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        (quote.solveForIUL.value != 'Cashflow' && evalproductTypeIULGuard(parameterStore, quote)) ||
        evalproductTypeWHLGuard(parameterStore, quote)
    );
};
const evalproductTypeNotProsperGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return !evalproductTypeProsperGuard(parameterStore, quote);
};
const evalproductTypeNotProsperMOOIULFGPathsetterGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        !evalproductTypeProsperGuard(parameterStore, quote) &&
        !evalproductTypeIULAndmooYesGuard(parameterStore, quote) &&
        !evalfgpathsetteryesGuard(parameterStore, quote)
    );
};
const evaldisbursementyesANDproductTypeIULORproductTypeWHLGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        quote.disbursement.value == true &&
        (evalproductTypeIULGuard(parameterStore, quote) || evalproductTypeWHLGuard(parameterStore, quote))
    );
};
const evalameritasyesANDproductTypeIULGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return evalameritasYesGuard(parameterStore, quote) && evalproductTypeIULGuard(parameterStore, quote);
};
const evalameritasyesANDfixedInterestsp1yrspAdjustsp2yrrussellbnp1yrbnp2yrNot100ANDproductTypeIULGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return (
        evalameritasYesGuard(parameterStore, quote) &&
        quote.fixedInterest.value +
            quote.sp1yr.value +
            quote.spAdjust.value +
            quote.sp2yr.value +
            quote.russell.value +
            quote.bnp1yr.value +
            quote.bnp2yr.value !=
            100 &&
        evalproductTypeIULGuard(parameterStore, quote)
    );
};
const evalaccidentalBenefityesANDameritasyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.accidentalBenefit.value == true && evalameritasYesGuard(parameterStore, quote);
};
const evalchildrensRideryesANDameritasyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.childrensRider.value == true && evalameritasYesGuard(parameterStore, quote);
};
const evallifetimeIncomeRideryesANDameritasyesGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.lifetimeIncomeRider.value == true && evalameritasYesGuard(parameterStore, quote);
};
const evalproductTypeVULANDsolveScenarioVULSetpremiumsolveforminimumnonmecfaceamountORsolveScenarioVULSetpremiumsolvefortargetfaceamountGuard =
    (parameterStore: ParameterStore, quote: Quote) => {
        return (
            evalproductTypeVULGuard(parameterStore, quote) &&
            (quote.solveScenarioVUL.value == 'Setpremiumsolveforminimumnonmecfaceamount' ||
                quote.solveScenarioVUL.value == 'Setpremiumsolvefortargetfaceamount')
        );
    };
const evalproductTypeVULANDsolveScenarioVULSetfaceamountsolveformaximumnonmecpremiumORsolveScenarioVULSetfaceamountsolvefortargetpremiumGuard =
    (parameterStore: ParameterStore, quote: Quote) => {
        return (
            evalproductTypeVULGuard(parameterStore, quote) &&
            (quote.solveScenarioVUL.value == 'Setfaceamountsolveformaximumnonmecpremium' ||
                quote.solveScenarioVUL.value == 'Setfaceamountsolvefortargetpremium')
        );
    };
const evalproductTypeVULANDdeathBenefitOptionVULIncreasingthenLevelGuard = (
    parameterStore: ParameterStore,
    quote: Quote,
) => {
    return evalproductTypeVULGuard(parameterStore, quote) && quote.deathBenefitOptionVUL.value == 'IncreasingthenLevel';
};
const evalproductTypeTermANDproductTermAmeritasFLXLivingBenefitsTermORproductTermNorthAmericanTermADDvantageORproductTermAssurityLifeInsuranceCompanyTermLifeInsuranceGuard =
    (parameterStore: ParameterStore, quote: Quote) => {
        return (
            evalproductTypeTermGuard(parameterStore, quote) &&
            (quote.productTerm.value == 'AmeritasFLXLivingBenefitsTerm' ||
                quote.productTerm.value == 'NorthAmericanTermADDvantage' ||
                quote.productTerm.value == 'AssurityLifeInsuranceCompanyTermLifeInsurance')
        );
    };
const evalchildrensRiderTermSelectoryesANDproductTypeTermANDproductTermAmeritasFLXLivingBenefitsTermORproductTermNorthAmericanTermADDvantageORproductTermAssurityLifeInsuranceCompanyTermLifeInsuranceGuard =
    (parameterStore: ParameterStore, quote: Quote) => {
        return (
            quote.childrensRiderTermSelector.value == true &&
            evalproductTypeTermGuard(parameterStore, quote) &&
            (quote.productTerm.value == 'AmeritasFLXLivingBenefitsTerm' ||
                quote.productTerm.value == 'NorthAmericanTermADDvantage' ||
                quote.productTerm.value == 'AssurityLifeInsuranceCompanyTermLifeInsurance')
        );
    };
const evalproductTypeADBGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productType.value === 'ADB';
};
const evalProductADBGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return quote.productADB.value === 'MOOGuaranteedADvantage';
};
const evalinvalidstatesADBGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        ['MA', 'MN', 'NM'].includes(parameterStore.prequal?.state.value) &&
        evalProductADBGuard(parameterStore, quote) &&
        evalproductTypeADBGuard(parameterStore, quote)
    );
};
const evalinvalidreturnOnPremiumADBGuard = (parameterStore: ParameterStore, quote: Quote) => {
    return (
        evalproductTypeADBGuard(parameterStore, quote) &&
        quote.returnOnPremiumADB.value &&
        (parameterStore.prequal?.age.value < 18 ||
            parameterStore.prequal?.age.value > 50 ||
            (quote.planTypeADB.value === '_2Adults' &&
                (+quote.secondCoveredAdultAgeADB.value < 18 || +quote.secondCoveredAdultAgeADB.value > 50)) ||
            ['AR', 'CT', 'GA', 'NY', 'PA', 'VA'].includes(parameterStore.prequal?.state.value))
    );
};

export const quoteGuards: {[key: string]: (parameterStore: ParameterStore, quote: Quote) => boolean} = {
    productIUL: evalproductTypeIULGuard,
    productTerm: evalproductTypeTermGuard,
    productGUL: evalproductTypeGULGuard,
    productGuaranteed: evalproductTypeGuaranteedGuard,
    productVUL: evalproductTypeVULGuard,
    productWHL: evalproductTypeWHLGuard,
    healthRatingLSWIUL: evalproductTypeLSWIULGuard,
    healthRatingAmeritasJuvenile: evalproductTypeIULANDameritasYesANDageLt18Guard,
    healthRatingAmeritasJuvenileVUL: evalproductTypeVULANDameritasYesANDageLt18Guard,
    healthRatingAmeritasAdult: evalproductTypeIULANDameritasYesANDageGte18Guard,
    healthRatingAmeritasAdultVUL: evalproductTypeVULANDameritasYesANDageGte18Guard,
    healthRatingAmeritasTerm: evalproductTypeTermANDameritasYesGuard,
    healthRatingMOOIUL: evalproductTypeIULAndmooYesGuard,
    healthRatingMOOWHL: evalproductTypeWHLAndmooYesGuard,
    healthRatingFGIUL: evalproductTypeIULAndFGPathsetterYesGuard,
    tableRatingFGIUL: evalproductTypeIULAndFGPathsetterYesAndStandardGuard,
    smokerRatingAmeritasTerm: evalproductTypeTermANDameritasYesGuard,
    smokerRatingAssurityTerm: evalproductTypeTermANDassurityLifeYesGuard,
    healthRatingLSW: evallswYesGuard,
    healthRatingAssurityTerm: evalassurityLifeYesGuard,
    smokerRatingLSW: evallswYesGuard,
    healthRatingNA: evalnorthAmericanYesGuard,
    smokerRatingNA: evalnorthAmericanYesGuard,
    healthRatingMOO: evalmooyesGuard,
    smokerRatingMOO: evalmooyesGuard,
    tableRatingAmeritas: evalameritasTableRatingGuard,
    tableRatingLSWIUL: evalLSWIULTableRatingGuard,
    tableRatingLSWIUL2: evalproductTypeLSWIULGuard,
    tableRatingAmeritasTerm: evalameritasTermTableRatingGuard,
    tableRatingAmeritasVUL: evalameritasVULTableRatingGuard,
    tableRatingLSW: evalLSWTableRatingGuard,
    tableRatingNA: evalNATableRatingGuard,
    flatExtra: evalproductTypeNotGuaranteedANDproductTypeNotProsperGuard,
    prosperRiskClass: evalproductTypeProsperGuard,
    prosperFaceAmount: evalproductTypeProsperGuard,
    prosperIllustrationRequest: evalproductTypeProsperGuard,
    prosperPremium: evalproductTypeProsperGuard,
    prosperFlatExtra: evalproductTypeProsperANDprosperRiskClassStandardTobaccoORprosperRiskClassStandardNonTobaccoGuard,
    prosperIndexedAccountAllocation: evalproductTypeProsperGuard,
    prosperFixedAccountAllocation: evalproductTypeProsperGuard,
    // prosperAllocationPercent: evalprosperFixedAccountAllocationPlusprosperIndexedAccountAllocationNot100Guard,
    prosperPremiumType: evalproductTypeProsperGuard,
    prosperIllustrationROR: evalproductTypeProsperGuard,
    prosperPremiumMode: evalproductTypeProsperGuard,
    prosperPremiumYearsType: evalproductTypeProsperGuard,
    prosperPremiumYears: evalproductTypeProsperGuard,
    prosperTableRating:
        evalproductTypeProsperANDprosperRiskClassStandardTobaccoORprosperRiskClassStandardNonTobaccoGuard,
    prosperDeathBenefitOption: evalproductTypeProsperGuard,
    prosperDeathBenefitOptionSwitchYear: evalproductTypeProsperANDprosperDeathBenefitOptionBIncreasingGuard,
    prosperTaxTest: evalproductTypeProsperGuard,
    prosperMECTesting: evalproductTypeProsperGuard,
    prosperLumpSumPremium: evalproductTypeProsperGuard,
    prosperDistributionAmount: evalproductTypeProsperGuard,
    prosperDistributionStartYear: evalproductTypeProsperGuard,
    prosperDistributionEndYear: evalproductTypeProsperGuard,
    flatExtraPerm: evalflatExtrayesGuard,
    flatExtraYears: evalflatExtrayesANDameritasyesornorthAmericanyesGuard,
    flatExtraTemp: evalflatExtrayesANDameritasyesornorthAmericanyesGuard,
    easySolveOptionIULMoo: evalmooyesGuard,
    easySolveOptionWHLMoo: evaleasySolveOptionWHLMooproductTypeWHLAndmooYesGuard,
    solveScenario: evalproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard,
    solveDetailsPremium:
        evalsolveScenarioPremiumknowncoverageANDproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard,
    solveDetailsCoverage: evalsolveScenarioCoverageknownpremiumANDproductTypeIULGuard,
    specifiedFaceAmount: evalproductTypeTermorproductTypeGULGuard,
    specifiedFaceAmountLSW: evalproductTypeLSWIULGuard,
    specifiedFaceAmountWinflex: evalfaceAmountSpecifiedANDproductTypeIULLORproductTypeWHLGuard,
    specifiedFaceAmountMOO: evalmooyesGuard,
    specifiedFaceAmountTransGerber: evalproductGuaranteedGerberFinalExpenseANDproductTypeGuaranteedGuard,
    specifiedFaceAmountGW: evalproductGuaranteedGreatWesternFinalExpenseANDproductTypeGuaranteedGuard,
    complianceTest: evalproductTypeIULAndameritasYesGuard,
    complianceTestLSWIUL: evalproductTypeLSWIULGuard,
    complianceTestVUL: evalproductTypeVULGuard,
    mecAvoidance:
        evalproductTypeIULORproductTypeVULORproductTypeWHLANDcomplianceTestNotCashValueAccumulationTestNotFGPathsetterGuard,
    mecAvoidanceLSWIUL: evalproductTypeLSWIULGuard,
    deathBenefitOption: evalproductTypeIULORroductTypeWHLGuard,
    deathBenefitOptionMOOIUL: evalproductTypeIULAndmooYesGuard,
    deathBenefitOptionFGPathsetter: evalfgpathsetteryesGuard,
    deathBenefitChangeYear: evalageLt70ANDproductTypeIULANDpremiumSolveOptionLSWNotMinimumPremiumORproductTypeWHLGuard,
    solveForIUL: evalproductTypeIULANDameritasyesGuard,
    solveForIULMoo: evalproductTypeIULAndmooYesGuard,
    solveForWHLMoo: evalproductTypeWHLAndmooYesGuard,
    deathBenefitOptionLSWIUL: evalproductTypeLSWIULGuard,
    deathBenefitChangeAgeLSW: evalageLt70ANDproductTypeLSWIULGuard,
    solveForIULLSW: evalproductTypeIULANDlswFlexLifeNLyesORlswFlexLifeyesGuard,
    solveTargetLSWIUL: evalproductTypeLSWIULGuard,
    firstYearLumpSumLSWIUL: evalproductTypeLSWIULGuard,
    deductFirstModalPremiumFromLumpSum: evalproductTypeLSWIULGuard,
    solveForGUL: evalproductTypeGULGuard,
    faceAmount: evalsolveForIULNotFaceamountANDproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard,
    deathBenefitGuaranteeAge: evalproductTypeGULGuard,
    termPeriod: evalproductTypeTermANDproductTermNotAssurityLifeInsuranceCompanyTermLifeInsuranceGuard,
    termPeriodAssurity: evalproductTypeTermANDproductTermAssurityLifeInsuranceCompanyTermLifeInsuranceGuard,
    faceSolveOption: evalsolveForIULFaceamountANDproductTypeIULGuard,
    faceSolveOptionFGPathsetter: evalsolveForIULFGPathsetterFaceSolve,
    premiumMode: evalproductTypeIULANDsolveForIULNotPremiumANDameritasyesGuard,
    premiumModeLSW: evalproductTypeIULANDlswFlexLifeNLyesORlswFlexLifeyesANDsolveForIULLSWNotPremiumGuard,
    specifiedPremium: evalpremiumModeSpecifiedpremiumANDproductTypeIULORproductTypeWHLGuard,
    specifiedPremiumFGPathsetter: evalpremiumModeSpecifiedpremiumANDproductTypeFGPathsetterGuard,
    premiumSolveOption: evalsolveForIULPremiumANDproductTypeIULANDproductIULAmeritasIULFLXlivingbenefitsGuard,
    premiumSolveOptionLSW:
        evalsolveForIULLSWPremiumANDproductTypeIULANDproductIULNotAmeritasNotMOOIULFLXlivingbenefitsGuard,
    premiumEndAgeAmeritas: evalsolveForIULNotPremiumORsolveForIULLSWNotPremiumANDproductTypeIULGuard,
    specifiedPremiumEndAgeAmeritas: evalpremiumEndAgeAmeritasspecifiedageANDproductTypeIULGuard,
    specifiedPremiumEndAgeFGPathsetter: evalpremiumModeSpecifiedpremiumANDproductTypeFGPathsetterGuard,
    cashValueTargetAge: evalsolveForIULPremiumORsolveForIULFaceamountORsolveForIULLSWPremiumANDproductTypeIULGuard,
    cashValueTargetAmount: evalsolveForIULPremiumORsolveForIULFaceamountORsolveForIULLSWPremiumANDproductTypeIULGuard,
    cashFlowStartAge: evalsolveForIULCashflowANDproductTypeIULGuard,
    cashFlowEndAge: evalsolveForIULCashflowANDproductTypeIULGuard,
    cashFlowSolveOption: evalsolveForIULCashflowANDproductTypeIULGuard,
    premiumFrequency: evalproductTypeNotProsperMOOIULFGPathsetterGuard,
    //premiumFrequencyMOOIUL: evalproductTypeIULAndmooYesGuard,
    //premiumFrequencyFGPathsetter: evalfgpathsetteryesGuard,
    lumpSumFGPathSetter: evalfgpathsetteryesGuard,
    lswPremiumSolveType1: evalproductTypeLSWIULGuard,
    lswPremiumAmount1: evalproductTypeLSWIULGuard,
    lswPremiumStart1: evalproductTypeLSWIULGuard,
    lswPremiumEnd1: evalproductTypeLSWIULGuard,
    lswPremiumSolveType2: evalproductTypeLSWIULGuard,
    lswPremiumAmount2: evalproductTypeLSWIULGuard,
    lswPremiumStart2: evalproductTypeLSWIULGuard,
    lswPremiumEnd2: evalproductTypeLSWIULGuard,
    lswPremiumSolveType3: evalproductTypeLSWIULGuard,
    lswPremiumAmount3: evalproductTypeLSWIULGuard,
    lswPremiumStart3: evalproductTypeLSWIULGuard,
    lswPremiumEnd3: evalproductTypeLSWIULGuard,
    lswPremiumSolveType4: evalproductTypeLSWIULGuard,
    lswPremiumAmount4: evalproductTypeLSWIULGuard,
    lswPremiumStart4: evalproductTypeLSWIULGuard,
    lswPremiumEnd4: evalproductTypeLSWIULGuard,
    lswPremiumSolveType5: evalproductTypeLSWIULGuard,
    lswPremiumAmount5: evalproductTypeLSWIULGuard,
    lswPremiumStart5: evalproductTypeLSWIULGuard,
    lswPremiumEnd5: evalproductTypeLSWIULGuard,
    disbursement: evalsolveForIULNotCashflowANDproductTypeIULORroductTypeWHLGuard,
    incomeOption: evaldisbursementyesANDproductTypeIULORproductTypeWHLGuard,
    incomeStartAge: evaldisbursementyesANDproductTypeIULORproductTypeWHLGuard,
    incomeEndAge: evaldisbursementyesANDproductTypeIULORproductTypeWHLGuard,
    annualIncomeAmount: evaldisbursementyesANDproductTypeIULORproductTypeWHLGuard,
    overloanProtection: evaldisbursementyesANDproductTypeIULORproductTypeWHLGuard,
    fixedInterest: evalameritasyesANDproductTypeIULGuard,
    sp1yr: evalameritasyesANDproductTypeIULGuard,
    spAdjust: evalameritasyesANDproductTypeIULGuard,
    sp2yr: evalameritasyesANDproductTypeIULGuard,
    russell: evalameritasyesANDproductTypeIULGuard,
    bnp1yr: evalameritasyesANDproductTypeIULGuard,
    bnp2yr: evalameritasyesANDproductTypeIULGuard,
    fundPercentValidation:
        evalameritasyesANDfixedInterestsp1yrspAdjustsp2yrrussellbnp1yrbnp2yrNot100ANDproductTypeIULGuard,
    acceleratedBenefit: evalproductTypeIULORroductTypeWHLGuard,
    accidentalBenefit: evalameritasyesANDproductTypeIULGuard,
    accidentalBenefitAmount: evalaccidentalBenefityesANDameritasyesGuard,
    accidentalBenefitRating: evalaccidentalBenefityesANDameritasyesGuard,
    accidentalBenefitToAge: evalaccidentalBenefityesANDameritasyesGuard,
    childrensRider: evalproductTypeIULANDameritasyesGuard,
    childrensRiderAmount: evalchildrensRideryesANDameritasyesGuard,
    childrensRiderToAge: evalchildrensRideryesANDameritasyesGuard,
    lifetimeIncomeRider: evalameritasyesANDproductTypeIULGuard,
    lifetimeIncomeType: evallifetimeIncomeRideryesANDameritasyesGuard,
    lifetimeIncomeStartAge: evallifetimeIncomeRideryesANDameritasyesGuard,
    solveScenarioVUL: evalproductTypeVULGuard,
    premiumAmountVUL:
        evalproductTypeVULANDsolveScenarioVULSetpremiumsolveforminimumnonmecfaceamountORsolveScenarioVULSetpremiumsolvefortargetfaceamountGuard,
    faceAmountVUL:
        evalproductTypeVULANDsolveScenarioVULSetfaceamountsolveformaximumnonmecpremiumORsolveScenarioVULSetfaceamountsolvefortargetpremiumGuard,
    premiumPayToAgeVUL: evalproductTypeVULGuard,
    mainRateVUL: evalproductTypeVULGuard,
    deathBenefitOptionVUL: evalproductTypeVULGuard,
    deathBenefitChangeAgeVUL: evalproductTypeVULANDdeathBenefitOptionVULIncreasingthenLevelGuard,
    childrensRiderTermSelector:
        evalproductTypeTermANDproductTermAmeritasFLXLivingBenefitsTermORproductTermNorthAmericanTermADDvantageORproductTermAssurityLifeInsuranceCompanyTermLifeInsuranceGuard,
    childRiderUnitsTerm:
        evalchildrensRiderTermSelectoryesANDproductTypeTermANDproductTermAmeritasFLXLivingBenefitsTermORproductTermNorthAmericanTermADDvantageORproductTermAssurityLifeInsuranceCompanyTermLifeInsuranceGuard,
    DeathBenefitProtection: evalproductTypeIULORroductTypeWHLGuard,
    deathBenefitProtection: evalproductTypeLSWIULGuard,
    ABRTerminalIllness: evalproductTypeLSWIULGuard,
    ABRChronicIllness: evalproductTypeLSWIULGuard,
    ABRCriticalIllness: evalproductTypeLSWIULGuard,
    ABRCriticalInjury: evalproductTypeLSWIULGuard,
    ABRSummaryAge: evalproductTypeLSWIULGuard,
    includeReportLsw: evalproductTypeLSWIULGuard,
    SP500AllocationPercentage: evalproductTypeLSWIULGuard,
    USPacesetterAllocationPercentage: evalproductTypeLSWIULGuard,
    // TAFE guards
    healthRatingTAFE: evalproductTypeTAFEGuard,
    solveForTAFE: evalproductTypeTAFEGuard,
    specifiedPremiumTAFE: evalproductTypeTAFEGuard,
    specifiedFaceAmountTAFE: evalproductTypeTAFEGuard,
    premiumFrequencyTAFE: evalproductTypeTAFEGuard,
    // ADB guards
    productTypeADB: evalproductTypeADBGuard,
    productADB: evalProductADBGuard,
    invalidStatesADB: evalinvalidstatesADBGuard,
    invalidReturnOnPremiumADB: evalinvalidreturnOnPremiumADBGuard,
};
